import React, { useEffect, useState } from 'react';
import '../App.css';
import Sidebar from '../components/Sidebar';
import { LoginModal } from '../components/LoginModal';
import Banner from '../assets/Banner.png';
import CarouselSlider from '../components/CarouselSlider';
import Slider from "react-slick";
import Card_1 from '../components/Card_1';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MobileNav from '../components/MobileNav';
import Header from '../components/Header';
import SkeletonCircleText from '../components/SkeletonCircleText';
import SkeletonVideoCard from '../components/SkeletonVideoCard';


export default function Home() {


    const navigate = useNavigate();
    const [channels, setChannels] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState(0);
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();

    // Sync selectedChannel with query param
    useEffect(() => {
        const index = parseInt(searchParams.get("channel") || "0", 10);
        setSelectedChannel(index);
    }, [searchParams]);




    useEffect(() => {
        setLoading(true);
        let attempts = 0;
        const maxAttempts = 10;
        const interval = setInterval(() => {
            const data = sessionStorage.getItem("PK_Data");

            if (data) {
                try {
                    const parsed = JSON.parse(data);
                    if (parsed?.channels?.length > 0) {
                        setChannels(parsed.channels);
                        setLoading(false);
                        clearInterval(interval);
                    }
                } catch (err) {
                    console.error("Failed to parse session data", err);
                    setLoading(false);
                    clearInterval(interval);
                }
            }

            attempts++;
            if (attempts >= maxAttempts) {
                console.warn("PK_Data not found after multiple attempts");
                setLoading(false);
                clearInterval(interval);
            }
        }, 1000); // retry every 500ms

        return () => clearInterval(interval); // cleanup
    }, []);





    const sliderSettings = {
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3, slidesToScroll: 3 }
            },
            {
                breakpoint: 600,
                settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 2, slidesToScroll: 1 }
            }
        ]
    };

    return (
        <div>
            <Sidebar
                SelectedChannel={selectedChannel}
                onChannelSelect={(index) => setSelectedChannel(index)}
            />

            <section className='body_section'>
                <Header />

                {/* Carousel */}
                <div id="carouselExampleSlidesOnly" className="carousel slide mt-3" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={Banner} className="carousel-image" alt="Banner" />
                        </div>
                        {channels.slice(0, 3).map((channel, index) => (
                            <div className="carousel-item" key={index}>
                                <img className="carousel-image" src={channel.bannerImage} alt={channel.name} />
                                <div className="carousel-caption">
                                    <h2 className='bold text-light'>{channel.name}</h2>
                                    <p className='text-light'>{channel.description}</p>
                                    <button className='btn btn-primary' onClick={()=>window.location.href=`/?channel=${index}`}>Watch Now</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className='mt-4'>
                    <CarouselSlider
                        channels={channels}
                        onChannelSelect={(index) => setSelectedChannel(index)}
                    />
                </div>

                <div className='d-flex flex-column justify-content-between'>
                    {!loading && channels[selectedChannel] ? (
                        <>
                            <h3 className='bold mt-4 mb-0' style={{ color: 'var(--main-yellow)' }}>
                                {channels[selectedChannel].name}
                            </h3>
                            {channels[selectedChannel].playlists?.slice(0, 10).map((playlist, idx) => (
                                <div className='mt-4' key={idx}>
                                    <div className='d-flex flex-row align-items-center justify-content-between mb-2'>
                                        <h6 className='bold'>{playlist.name}</h6>
                                        <button
                                            className='btn btn-secondary view-all'
                                            onClick={() => navigate(`/single`, { state: { playlist } })}>
                                            View All
                                        </button>
                                    </div>

                                    <div className="slider-container">
                                        <Slider {...sliderSettings}>
                                            {playlist.content.slice(0, 10).map((vid, vidIdx) => (
                                                <Card_1 key={vidIdx} video={vid} playlist={playlist} />
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : (
                        <div>
                            <Slider {...sliderSettings}>
                                    {[...Array(10)].map((_, vidIdx) => (
                                        <SkeletonCircleText key={vidIdx} />
                                    ))}
                                </Slider>

                            <div className="skeleton" style={{ width: '100px', height: '20px' }} />

                            <div className="slider-container">
                                <Slider {...sliderSettings}>
                                    {[...Array(8)].map((_, vidIdx) => (
                                        <SkeletonVideoCard key={vidIdx} />
                                    ))}
                                </Slider>
                            </div>

                            <div className="skeleton mt-4" style={{ width: '100px', height: '20px' }} />

                            <div className="slider-container">
                                <Slider {...sliderSettings}>
                                    {[...Array(8)].map((_, vidIdx) => (
                                        <SkeletonVideoCard key={vidIdx} />
                                    ))}
                                </Slider>
                            </div>



                            <div className="skeleton mt-4" style={{ width: '100px', height: '20px' }} />

                            <div className="slider-container">
                                <Slider {...sliderSettings}>
                                    {[...Array(8)].map((_, vidIdx) => (
                                        <SkeletonVideoCard key={vidIdx} />
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    )}
                </div>
            </section>

            <MobileNav />
        </div>
    );
}
